(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbStatusService', [
			'$http',
			'$q',
			'smbContentTypeAcls',
			'pxUriPathService',
			StatusService
		]);

	function StatusService($http, $q, smbContentTypeAcls, pxUriPathService) {

		return {
			getStatuses: getStatuses,

			getDocumentStatus: getDocumentStatus,

			getUsers: getUsers,

			setDocumentStatus: setDocumentStatus
		};

		function getStatuses(folderId) {
			if (!(typeof folderId === 'string' || typeof folderId === 'number')) {
				return $q.reject(new Error('Missing required document type id'));
			}

			var uri = pxUriPathService.resolvePath('/f/' + folderId + '/tagtypes');
			return $http.get(uri)
				.then(function(res) {
					return res.data;
				});
		}

		function getDocumentStatus(documentId) {
			var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/status');
			return $http.get(uri)
				.then(function(res) { 
					return res.data.TypedTags; 
				});
		}

		function getUsers(documentId) {
			var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/users?acl=' + smbContentTypeAcls.MODIFY_DOCUMENTS);
			return $http.get(uri)
				.then(function(res) {
					return res;
				});
		}

		function setDocumentStatus(status, documentId) {
			var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/status');
			return $http.put(uri, status)
				.then(function (response) {
					return response;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/statusService.js
// module id = 159
// module chunks = 1